"use client";

import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";

type AuthProviderProps = {
  children: React.ReactNode;
  session?: Session | null;
};

/**
 * Auth provider component that wraps the app with NextAuth SessionProvider
 * This provides authentication context to all child components
 */
export function AuthProvider({ children, session }: AuthProviderProps) {
  return (
    <SessionProvider
      refetchInterval={5 * 60}
      refetchOnWindowFocus={true}
      session={session}
    >
      {children}
    </SessionProvider>
  );
}
